/* global YT */
"use strict";

function BackgroundVideo(videoElem, index) {
    this.videoStart = 0;
    this.player = [];
    this.youtubeId = videoElem.getAttribute("data-youtube-id");
    this.defaultVideoWidth = 16;
    this.defaultVideoHeight = 9;

    this.onPlayerReady = event => {
        this.vidRescale();
        event.target.mute();
        event.target.seekTo(this.videoStart);

        const thisVideo = event.target;
        const buttonSoundYoutube = videoElem.getElementsByClassName(
            "background-video__youtube-sound"
        )[0];
        const soundOffBtn = videoElem.getElementsByClassName(
            "background-video__youtube-sound-off"
        )[0];
        const soundOnBtn = videoElem.getElementsByClassName(
            "background-video__youtube-sound-on"
        )[0];

        if (buttonSoundYoutube != null) {
            buttonSoundYoutube.addEventListener("click", () => {
                if (thisVideo.isMuted()) {
                    thisVideo.unMute();
                    soundOnBtn.classList.remove(
                        "background-video__sound-on--active"
                    );
                    soundOffBtn.classList.add(
                        "background-video__sound-off--active"
                    );
                } else {
                    thisVideo.mute();
                    soundOnBtn.classList.add(
                        "background-video__sound-on--active"
                    );
                    soundOffBtn.classList.remove(
                        "background-video__sound-off--active"
                    );
                }
            });
        }
    };

    this.onPlayerStateChange = el => {
        if (el.data === 1) {
            const tv2 = videoElem.getElementsByClassName("screen")[0];
            tv2.classList.add("active");
        } else if (el.data === 0) {
            this.player[index].seekTo(this.videoStart);
        }
    };

    this.vidRescale = function rescaleVideo(event) {
        const containerElem = videoElem.querySelector(".tv");
        console.log(containerElem);
        if (containerElem != null) {
            // const containerElem = tvScreen.parentNode.parentNode.parentNode;
            const containerHeight = containerElem.offsetHeight;
            const containerWidth = containerElem.offsetWidth;
            if (
                containerWidth / containerHeight >
                this.defaultVideoWidth / this.defaultVideoHeight
            ) {
                this.player[index].setSize(
                    containerWidth,
                    (containerWidth / this.defaultVideoWidth) * this.defaultVideoHeight
                );
            } else {
                this.player[index].setSize(
                    (containerHeight / this.defaultVideoHeight) * this.defaultVideoWidth,
                    containerHeight
                );
            }
        }
    };

    this.onYouTubeIframeAPIReady = function apiReady() {
        this.player[index] = new YT.Player(`player${this.youtubeId}`, {
            videoId: this.youtubeId,
            playerVars: {
                autoplay: 1,
                loop: 1,
                controls: 0,
                rel: 0,
                modestbranding: 1,
                autohide: 1,
                showinfo: 0,
                disablekb: 1,
                enablejsapi: 0,
                iv_load_policy: 3
            },
            events: {
                onReady: this.onPlayerReady,
                onStateChange: this.onPlayerStateChange
            }
        });
    };
}
let APIHasBeenCalled = false;
const PhV = [];
const videos = document.getElementsByClassName(
    "background-video__youtube-wrapper"
);

for (let i = 0; i < videos.length; i++) {
    PhV[i] = new BackgroundVideo(videos[i], i);
}

function onYouTubeIframeAPIReady() {
    for (let i = 0; i < videos.length; i++) {
        PhV[i].onYouTubeIframeAPIReady();
        PhV[i].vidRescale();
    }
}

window.addEventListener(
    "load",
    () => {
        if (document.querySelector(".screen")) {
            const youtubeScriptTag = document.createElement("script");
            youtubeScriptTag.src = "https://www.youtube.com/player_api";

            const lastScriptTag = document.getElementsByTagName("script")[
                document.getElementsByTagName("script").length - 1
            ];
            lastScriptTag.parentNode.insertBefore(
                youtubeScriptTag,
                lastScriptTag
            );
        }
    },
    true
);

window.addEventListener(
    "resize",
    () => {
        for (let i = 0; i < videos.length; i++) {
            PhV[i].vidRescale();
        }
    },
    true
);
